"use strict";

import * as dom from "./lib/dom.js";

export default function () {
    function animaNumeros(element) {
        const numeros = element.querySelectorAll("[data-numero]");
        numeros.forEach((numero) => {
            const numeroTexto = numero.dataset.numero;
            const temVirgula = numeroTexto.includes(",");
            const total = parseFloat(numeroTexto.replace(",", ".")); // Convertendo o texto para número float
            const incremento = total / 100; // Incremento baseado em 100 partes
            let start = 0;
            const timer = setInterval(() => {
                start = parseFloat((start + incremento).toFixed(2)); // Arredondando para 2 casas decimais
                const formattedNumber = temVirgula
                    ? start.toLocaleString("pt-BR", {
                          maximumFractionDigits: 1,
                      })
                    : start; // Exibindo o número com uma casa decimal e vírgula como separador, se houver
                numero.innerText = formattedNumber;
                if (start >= total) {
                    numero.innerText = numeroTexto; // Restaurando o valor original
                    clearInterval(timer);
                }
            }, 25 * Math.random());
        });
        element.dataset.animado = "true"; // Marca o elemento como animado
    }

    function handleMutation(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (
                mutation.type === "attributes" &&
                mutation.attributeName === "class"
            ) {
                const target = mutation.target;
                if (
                    target.classList.contains("aos-animate") &&
                    !target.dataset.animado
                ) {
                    animaNumeros(target);
                    observer.disconnect(); // Desconecta o MutationObserver após a animação
                }
            }
        }
    }

    let observer = new IntersectionObserver(
        function (entries, observer) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    const target = entry.target;
                    let elements = target.querySelectorAll(".aos-init");
                    elements.forEach(function (element) {
                        const mutationObserver = new MutationObserver(
                            handleMutation
                        );
                        mutationObserver.observe(element, { attributes: true });
                    });
                    observer.unobserve(target);
                }
            });
        },
        { threshold: 0.1 }
    );

    document.querySelectorAll(".o-kilima-numeros").forEach(function (section) {
        observer.observe(section);
    });
}
